export const xlSize = 1441;
export const lSize = 1200;
export const mlSize = 992;
export const mSize = 768;
export const smSize = 576;
export const sSize = 450;
export const ssSize = 320;
